import { useState, useEffect, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import { debounce } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Loader from "../../../components/Loader/Loader";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import { userRows } from "../../../datatablesource";
import { Link } from "react-router-dom";
import "../../../components/common/css/datatable.scss";

const InvestmentList = () => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [campaignID, setCampaignID] = useState();
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });

  const fetchInvestData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-campaign-invest-listing",
      headers: {
        "x-access-token": token,
      },
      data: {
        page: pageState.page,
        limit: pageState.pageSize,
        searchTerm: query,
      },
    };

    axios(config)
      .then(function (response) {
        setPageState((old) => ({
          ...old,
          data: response?.data?.data?.rows,
          total: response?.data?.data?.count,
        }));
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchInvestData();
  }, [pageState.page, pageState.pageSize, query]);

  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "user_id",
      headerName: "User ID",
      width: 70,
    },

    {
      field: "user.firstname",
      headerName: "Name",
      width: 170,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params.row.user.firstname + " " + params.row.user.lastname}
          </div>
        );
      },
    },

    {
      field: "campaign_detail.campaign_name",
      headerName: "Campaign Name",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.campaign_detail?.campaign_name}
          </div>
        );
      },
    },
    {
      field: "campaign_detail.corporation_legal_name",
      headerName: "Corporate Name",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.campaign_detail?.corporation_legal_name}
          </div>
        );
      },
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 170,
    },
    {
      field: "currency",
      headerName: "Currency",
      width: 170,
    },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 170,
    },
    {
      field: "paymentOption",
      headerName: "Payment Method",
      width: 170,
    },
    {
      field: "user.profilePic",
      headerName: "Datetime",
      width: 200,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <div className="cellWrapper ">
            <div className="profilePic">
              {d?.getHours() + ":" + d?.getMinutes() + ", " + d?.toDateString()}
            </div>
          </div>
        );
      },
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <div className="cellAction">
              <Link
                to={`/suitability-overview/${params.row.id} `}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">
                  <RemoveRedEyeOutlinedIcon />
                </div>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input
            type="text"
            placeholder="Search Campaign..."
            onChange={handleQuery}
          />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Suitability Overview</h5>
        <div></div>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(actionColumn)}
      />
    </div>
  );
};

export default InvestmentList;
